import Immutable from 'seamless-immutable'
import { values } from 'lodash'
import { filterActions } from 'redux-ignore'

import * as types from './types'
const {
  SUBSCRIPTION_SUCCESS
} = types

const INITIAL_STATE = Immutable({
  success: false
})

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SUBSCRIPTION_SUCCESS:
      return state.set('success', true)
    default:
      return state
  }
}

export default filterActions(reducer, values(types))
